import SimpleInStream from 'components/Ad/AdSlot/SimpleInStream';
import ArticleGridWrapper from 'components/Grid/ArticleGrid/ArticleGridStyles';
import HUBPAGE_TEST_IDS from 'constants/testsIds/hubpage';
import useBreakpoint from 'hooks/useBreakpoint';
import { PageType } from 'interfaces/content/articles/Post';
import type { JSX } from 'react';

export interface ArticleGridProps {
  children: JSX.Element[];
  pageType: PageType;
  hideAds?: boolean;
  pageSize: number;
}

export function renderListWithAds(
  list: JSX.Element[],
  pageSize: number,
  hideAds: boolean | undefined,
  pageType: PageType,
  isMobile: boolean | undefined,
  isDesktop: boolean | undefined,
) {
  const isTablet = !isMobile && !isDesktop;
  const pageWithEmptySpace = [PageType.TAG, PageType.TOPIC, PageType.AUTHOR, PageType.PACKAGES, PageType.LATEST];
  let pageSizeAccordingToScreenSize = pageSize;

  if (pageWithEmptySpace.includes(pageType) && isTablet) {
    pageSizeAccordingToScreenSize = pageSize + 1;
  }

  const newChildren: JSX.Element[] = [];

  let elementCount = 0;

  for (let i = 0; i < list.length; i++) {
    if (pageType !== PageType.SECTION && elementCount === 6) {
      newChildren.push(
        <div className='nativo-rail'>
          <div />
        </div>,
      );
    }

    newChildren.push(list[i]);
    elementCount += 1;

    if (elementCount % 30 === 0) {
      newChildren.push(
        <div
          className='ad-div'
          key={`adDiv_${i}`}
        >
          {!hideAds && (
            <SimpleInStream
              id={i / pageSizeAccordingToScreenSize}
              pageType={PageType.HUB}
            />
          )}
        </div>,
      );
    }
  }

  return newChildren;
}

const ArticleGrid = ({ children, pageType, pageSize, hideAds }: ArticleGridProps) => {
  const isMobile = useBreakpoint('mdMax');
  const isDesktop = useBreakpoint('lgMin');
  const className = pageType === PageType.TAG ? 'grid' : 'termArchiveContentList';

  return (
    <ArticleGridWrapper>
      {/*
    Nativo current selector: ul[class^=termArchiveContentList]
    Styled components can't be directly used because their classNames start with an autogenerated string
    */}

      <section
        data-cy={HUBPAGE_TEST_IDS.HUBPAGE_ARTICLE_GRID}
        className={className}
      >
        {renderListWithAds(children, pageSize, hideAds, pageType, isMobile, isDesktop)}
      </section>
    </ArticleGridWrapper>
  );
};

export default ArticleGrid;
